import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.template.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-admin-template-item',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.template.item/view.scss */
/* src/app/page.admin.template.item/view.scss: no such file or directory */`],
})
export class PageAdminTemplateItemComponent implements OnInit, OnDestroy {
    public updating: boolean = false;
    public id: string = '';
    public tab: string = 'info';
    public data: any = { params: [] };
    public deploys: any[] = [];
    public deployCount: number = 0;
    public apiEndpointHost: string = '';

    private basePath: string = '/admin/template';
    private routerSub: any;

    // API Test
    public testActions = [
        { label: 'Create', value: 'start', method: 'POST', desc: 'Deploy 생성' },
        { label: 'Info', value: 'info', method: 'GET', desc: 'Deploy 상태 조회' },
        { label: 'Stop', value: 'stop', method: 'POST', desc: 'Deploy 중지' },
        { label: 'Restart', value: 'restart', method: 'POST', desc: 'Deploy 재시작' },
        { label: 'Delete', value: 'delete', method: 'DELETE', desc: 'Deploy 삭제' },
    ];
    public testAction: string = 'info';
    public testParams: any = {};
    public testBasename: string = 'test';
    public testResult: any = null;
    public testLoading: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'info';
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                const newTab = WizRoute.segment.tab || 'info';

                if (newId && newId !== this.id) {
                    this.id = newId;
                    this.tab = newTab;
                    await this.load();
                } else if (newTab !== this.tab) {
                    this.tab = newTab;
                    if (newTab === 'deploy') {
                        await this.loadDeploys();
                    } else if (newTab === 'test') {
                        this.initTestParams();
                    }
                    await this.service.render();
                }
            }
        });

        if (!WizRoute.segment.tab) {
            this.service.href(`${this.basePath}/${this.id}/info`);
            return;
        }

        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        if (this.id === 'new') {
            this.data = { params: [], archived: false };
            this.deployCount = 0;
            this.deploys = [];
            this.apiEndpointHost = '';
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href(this.basePath);
            return;
        }
        this.data = data;
        this.deployCount = data.deploy_count || 0;
        this.apiEndpointHost = data.api_endpoint_host || '';
        if (!this.data.params) this.data.params = [];

        if (this.tab === 'deploy') {
            await this.loadDeploys();
        } else if (this.tab === 'test') {
            this.initTestParams();
        }
        await this.service.render();
    }

    public async loadDeploys() {
        const { code, data } = await wiz.call("deploys", { id: this.id });
        if (code === 200) {
            this.deploys = data;
            this.deployCount = data.length;
        }
        await this.service.render();
    }

    public async updateIcon() {
        this.data.icon = await this.service.file.read({ type: 'image', accept: 'image/*', width: 64, quality: 1 });
        await this.service.render();
    }

    public async deleteIcon() {
        this.data.icon = "";
        await this.service.render();
    }

    public async addParams() {
        this.data.params.push({ name: "", type: "text", description: "" });
        await this.service.render();
    }

    public async deleteParams(item) {
        this.data.params.remove(item);
        await this.service.render();
    }

    public async update() {
        await this.service.render(this.updating = true);

        let pd = JSON.stringify(this.data);
        const { data } = await wiz.call("update", { data: pd });

        await this.service.sleep(1000);

        if (!data.id) {
            await this.service.render(this.updating = false);
            return;
        }

        if (this.id != data.id) {
            this.id = data.id;
            this.data = data;
            this.service.href(`${this.basePath}/${this.id}/${this.tab}`);
        }

        await this.service.render(this.updating = false);
    }

    public async archive() {
        if (!await this.service.modal.error(`Archive '${this.data.name}'?`, `Cancel`, `Archive`)) return;
        await wiz.call("archive", { id: this.id });
        await this.load();
    }

    public async unarchive() {
        if (!await this.service.modal.error(`Unarchive '${this.data.name}'?`, `Cancel`, `Unarchive`)) return;
        await wiz.call("unarchive", { id: this.id });
        await this.load();
    }

    public async delete() {
        if (!await this.service.modal.error(`Are you sure you want to permanently delete '${this.data.name}'? This action cannot be undone.`, `Cancel`, `Delete`)) return;
        const { code, data } = await wiz.call("delete", { id: this.id });
        if (code !== 200) {
            await this.service.modal.error(data.message || 'Delete failed', 'OK');
            return;
        }
        this.service.href(this.basePath);
    }

    public get canDelete(): boolean {
        return this.data.archived && this.deployCount === 0 && this.id !== 'new';
    }

    // API Token 관리 (외부 키 입력 방식)
    public async saveToken() {
        const token = (this.data.api_token || '').trim();
        const { code } = await wiz.call("save_token", { id: this.id, token });
        if (code === 200) {
            await this.service.render();
        }
    }

    public async clearToken() {
        if (!await this.service.modal.error('API 토큰이 삭제됩니다. 이 토큰을 사용하는 모든 API 호출에 영향을 줄 수 있습니다.', 'Cancel', 'Clear')) return;
        this.data.api_token = '';
        await this.saveToken();
    }

    public async copyToClipboard(text: string) {
        await navigator.clipboard.writeText(text);
    }

    public get endpointUrl(): string {
        const host = this.apiEndpointHost || 'https://k8s-api.season.co.kr';
        const name = this.data.deploy_name || '{deploy_name}';
        return `${host}/api/deploy/${name}`;
    }

    public statusColor(status: string): string {
        const colors: any = {
            'active': 'bg-emerald-100 text-emerald-700',
            'running': 'bg-emerald-100 text-emerald-700',
            'stopped': 'bg-gray-100 text-gray-600',
            'error': 'bg-red-100 text-red-700',
            'pending': 'bg-amber-100 text-amber-700',
            'deploying': 'bg-blue-100 text-blue-700',
        };
        return colors[status] || 'bg-gray-100 text-gray-600';
    }

    // ===== API Test =====
    public initTestParams() {
        this.testParams = {};
        if (this.data.params) {
            for (const p of this.data.params) {
                if (p.type === 'namespace' || p.name === 'namespace') continue;
                if (p.type === 'mode') continue;
                if (p.type === 'list' && p.description) {
                    const options = p.description.split(',').map((s: string) => s.trim()).filter((s: string) => s);
                    this.testParams[p.name] = options.length > 0 ? options[0] : '';
                } else {
                    this.testParams[p.name] = '';
                }
            }
        }
        this.testResult = null;
    }

    public get editableParams() {
        if (!this.data.params) return [];
        return this.data.params.filter((p: any) =>
            p.type !== 'namespace' && p.type !== 'mode' && p.name !== 'namespace'
        );
    }

    public selectTestAction(action: string) {
        this.testAction = action;
        this.service.render();
    }

    public get activeTestAction() {
        return this.testActions.find(a => a.value === this.testAction);
    }

    public async runTest() {
        this.testLoading = true;
        this.testResult = null;
        await this.service.render();

        const params = { ...this.testParams };
        params['namespace'] = 'development';
        params['basename'] = this.testBasename;

        const { code, data } = await wiz.call("test_api", {
            id: this.id,
            action: this.testAction,
            params: JSON.stringify(params)
        });

        this.testResult = { code, data };
        this.testLoading = false;
        await this.service.render();
    }

    public get testResultJson(): string {
        if (!this.testResult) return '';
        try {
            return JSON.stringify(this.testResult.data, null, 2);
        } catch {
            return String(this.testResult.data);
        }
    }
}

export default PageAdminTemplateItemComponent;